// ── useKalshiAccount — Auto-connect lifecycle hook (MT relay) ────
// On mount, checks the relay for stored credentials and connects if found.

import { useEffect } from 'react';
import { useAccountStore } from '../stores/accountStore';
import { useAuthStore } from '../stores/authStore';

export function useKalshiAccount(): void {
  const authStatus = useAuthStore((s) => s.status);

  useEffect(() => {
    if (authStatus !== 'authenticated') return;

    useAccountStore.getState().checkCredentials();

    return () => {
      useAccountStore.getState().disconnect();
    };
  }, [authStatus]);
}
